import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import CookieConsent from "react-cookie-consent";
import CookieIcon from "@mui/icons-material/Cookie";
import { useDarkModeData } from "src/context/DarkModeContext";

export default function CookieConsentIkkuna(props) {
  const { darkMode } = useDarkModeData();
  const handleAcceptKlik = () => props.onAccept();
  const styles = {
    ikkuna: {
      background: darkMode ? "#292929" : "#D9D9D9",
      color: darkMode ? "rgba(255,255,255,0.87)" : "rgba(0,0,0,0.87)",
    },
    nappi: {
      background: darkMode ? "#4D9093" : "#1f3a4d",
      color: !darkMode ? "rgba(255,255,255,0.87)" : "rgba(0,0,0,0.87)",
      fontSize: "18px",
      borderRadius: "5px",
      padding: "15px 25px 15px 25px",
    },
    flex: {
      display: "flex",
    },
  };
  return (
    <CookieConsent
      onAccept={handleAcceptKlik}
      location="bottom"
      buttonText="OK"
      cookieName="cookieConsentIkkuna"
      style={styles.ikkuna}
      buttonStyle={styles.nappi}>
      <CookieConsentContents />
    </CookieConsent>
  );

  function CookieConsentContents() {
    return (
      <>
        <div style={styles.flex}>
          <CookieIcon color="primary" />
          <Typography variant="h6" color="primary">
            Evästeet ja vastaavat tekniikat
          </Typography>
        </div>
        <Typography variant="body" color="primary">
          Käytämme evästeitä ja muita verkkotekniikoita tarjotaksemme sinulle paremman
          käyttäjäkokemuksen. Kun jatkat sivuston selailua, hyväksyt samalla evästeiden käytön.
        </Typography>
      </>
    );
  }
}

CookieConsentIkkuna.propTypes = {
  onAccept: PropTypes.func.isRequired,
};
